import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { USER_TYPES } from "../../Helpers/constants";

interface FloatingHeadProps {
  userType?: string;
  actions: {
    name: string;
    icon: React.JSX.Element;
    action: Dispatch<SetStateAction<boolean>>;
  }[];
  isMobile?: boolean;
}

export const FloatingHead: React.FC<FloatingHeadProps> = ({
  userType,
  actions,
  isMobile = false,
}) => (
  <SpeedDial
    ariaLabel="SpeedDial basic example"
    className="absolute md:top-28 md:left-2/3 md:bottom-auto md:right-auto top-auto left-auto bottom-4 right-6"
    icon={<SpeedDialIcon />}
    direction={isMobile ? "up" : "down"}
    sx={{ zIndex: 49 }}
    hidden={userType !== USER_TYPES.professional}
  >
    {actions.map((action) => (
      <SpeedDialAction
        key={action.name}
        icon={action.icon}
        tooltipTitle={action.name}
        onClick={() => action.action(true)}
      />
    ))}
  </SpeedDial>
);
